module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_quvitsecurity.f2182bcd87aa97ef72eb0e164b8751cb.png";